import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';
import { HelpService } from '~commonInfra/services/HelpService';
import { CompositeSessionInfoSelectors, SessionServerSelectors, SessionSiteSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { learnMoreStyle } from '../../../../styles/CommonStyles';
import { useSelector } from '../../../utils';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export type CatalogingSectionProps = SiteSettingsForSiteAdminProps<'catalogingEnabled'>;

export const CATALOGING_FIELD = 'settings.catalogingEnabled';

export function CatalogingSection(props: CatalogingSectionProps) {
  const isOnlineEnvironment = useSelector(SessionServerSelectors.isOnlineEnvironment);
  const catalogingEnabledOnServer = useSelector(SessionServerSelectors.catalogingOnServerEnabled);
  const catalogingEnabledOnSite = useSelector(SessionSiteSelectors.catalogingOnSiteEnabled);
  const isServerAdmin = useSelector(SessionUserSelectors.isSessionServerAdmin);
  const isOnlineSiteAdmin = useSelector(CompositeSessionInfoSelectors.currentUserIsOnlineSiteAdmin);
  const isAdmin = isServerAdmin || (isOnlineSiteAdmin && FeatureFlags.catalogSectionOnlineSiteAdminEnabled);
  const showSection = catalogingEnabledOnServer && isAdmin;
  const disableCheckbox = isOnlineEnvironment && catalogingEnabledOnSite;

  return (
    showSection
      ? <SettingsSection testId={'cataloging-setting-section'}
                         title={Messages.tableauCatalog()}
                         description={renderDescription()}>

        <FormikCheckbox name={CATALOGING_FIELD}
                        label={Messages.allowCatalogingOnSite()}
                        testId={'allow-cataloging-on-site-checkbox'}
                        disabled={disableCheckbox}/>
      </SettingsSection>

      : null // don't render the section if setting is not enabled on server. React requires returning null in this case
  );
}

function renderDescription() {
  return (
    <div>
      {Messages.catalogingOnSiteDetails()}
      <TextLinkWidget testId={'cataloging-learn-more-link'}
                      target={'_blank'}
                      className={learnMoreStyle}
                      href={HelpService.getServerHelpUrlByCategory('catalog-site-setting')}>
        {Messages.learnMore()}
      </TextLinkWidget>
    </div>
  );
}

export const CatalogingSectionSpecs = componentRegistryEntry({
  name: 'CatalogingSection',
  component: CatalogingSection
});
